/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
// import Cookie from 'universal-cookie';
import { useSelector } from 'react-redux';
import { Button, HeaderPage } from 'components';
import { Form, Select, Row, Col, DatePicker, message } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { ESTADOS, CONFIGURACION_SISTEMA } from 'constants/nombresCatalogos';
import dayjs from 'dayjs';
import { PdfGeocercas } from './PdfGeocercas';
import * as ubicacionService from '../../services/geocercas.services';
import { ListadoDirecciones } from './components/ListadoDirecciones';
import { Mapa } from './components/Mapa';
import './Geocercas.scss';
import { ReactComponent as InfoCircle } from '../../assets/images/InfoCircleExclamation/info_circle_exclamation.svg';

const mxCenter = {
  lat: 23.416371615752457,
  lng: -102.31726197109397
};

const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];

export function Geocercas() {
  const [form] = Form.useForm();
  const [map, setMap] = useState(null);
  const catalogoEstados = useSelector(selectCatalogByName(ESTADOS)).filter((e) => e.idEstado !== 0);
  const [catalogoMunicipios, setMunicipios] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [listaLocalidades, setListaLocalidades] = useState([]);
  const [listaCoordenadasSeleccionadas, setListaCoordenadasSeleccionadas] = useState([]);
  const [dataActa, setDataActa] = useState({});
  const [isModalPDF, setIsModalPDF] = useState(false);
  const [nombreEstadoSeleccionado, setNombreEstadoSeleccionado] = useState('');
  const [center, setCenter] = useState(mxCenter);
  const [zoomMap, setzoomMap] = useState(5);

  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const fechaIniciOper =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;
  const dateFormat = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);

  const limpiarMapa = () => {
    setListaLocalidades([]);
    setCenter(mxCenter);
    setzoomMap(5);
    setListaCoordenadasSeleccionadas([]);
    form.resetFields();
  };

  const handleGeocode = (parametro, zoom) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: `${parametro}, Mexico` }, (results, status) => {
      if (status === 'OK') {
        setCenter(results[0].geometry.location);
        setzoomMap(zoom);
      } else {
        console.error(`Geocode was not successful for the following reason: ${status}`);
      }
    });
  };

  const handleChangeEntidad = async (entidadId) => {
    if (listaLocalidades) setListaLocalidades([]);
    setListaCoordenadasSeleccionadas([]);
    form.setFieldsValue({ municipios: '' });
    const estadoSeleccionado = catalogoEstados.find((edo) => edo.idEstado === entidadId);
    if (!estadoSeleccionado) return;

    setNombreEstadoSeleccionado(estadoSeleccionado.nombreEstado);
    const municipiosFiltrados = estadoSeleccionado.municipios.map((m) => ({
      id: m.idMunicipio,
      nombre: m.nombreMunicipio
    }));
    setMunicipios(municipiosFiltrados);
    // const dataEstado = encodeURIComponent(estadoSeleccionado.nombreEstado);
    // const dota = await ubicacionService.respuestaGogle(dataEstado);
    // console.log('dotaPrueba', dotaPrueba);
    const parametros = `${estadoSeleccionado.nombreEstado}`;
    handleGeocode(parametros, 10);
    // if (dota.data.status === 'OK') {
    //   const cordendasCentro = dota.data.results[0].geometry.location;
    //   setCenter(cordendasCentro);
    //   setzoomMap(10);
    // }
  };

  const handleChangeMunicipio = async (municipioId) => {
    if (listaLocalidades) setListaLocalidades([]);
    setListaCoordenadasSeleccionadas([]);
    const municipioSeleccionado = catalogoMunicipios.find((m) => m.id === municipioId);
    if (!municipioSeleccionado) return;
    // const dataMunicipio = encodeURIComponent(municipioSeleccionado.nombre);
    // const dota = await ubicacionService.respuestaGogle(dataMunicipio);
    // if (dota.data.status === 'OK') {
    //   const cordendasCentro = dota.data.results[0].geometry.location;
    //   setCenter(cordendasCentro);
    //   setzoomMap(15);
    // }
    const parametros = `${municipioSeleccionado.nombre},${nombreEstadoSeleccionado}`;
    handleGeocode(parametros, 15);
  };

  const handleBusquedaLocaciones = async () => {
    const fields = await form.validateFields();
    let municipioApi = '';
    setDataActa(fields);
    try {
      // eslint-disable-next-line array-callback-return
      catalogoEstados.map((e) => {
        if (fields.entidad === e.idEstado) {
          setNombreEstadoSeleccionado(e.nombreEstado);
          // eslint-disable-next-line array-callback-return
          e.municipios.map((m) => {
            if (fields.municipios === m.idMunicipio) {
              municipioApi = m.nombreMunicipio;
            }
          });
        }
      });
      // const coki = new Cookie();
      // const tokenn = coki.get('JWT-TOKEN-SIMAC');
      const peticion = {
        token: '',
        // monitoreos: {
        idEstado: '',
        idMunicipio: '',
        fecha: ''
        // }
      };
      const fecha = fields.fechaMonitoreo.$d.toISOString();
      const año = fecha.substring(0, 4);
      const mes = fecha.substring(5, 7);
      const dia = fecha.substring(8, 10);
      const segundos = '000000';
      const fechaJson = `${año}${mes}${dia}${segundos}`;
      // peticion.token = tokenn;
      // peticion.monitoreos.idEstado = fields.entidad;
      // peticion.monitoreos.idMunicipio = fields.municipios;
      // peticion.monitoreos.fecha = fechaJson;
      peticion.idEstado = fields.entidad;
      peticion.idMunicipio = fields.municipios;
      peticion.fecha = fechaJson;
      const parametros = `${municipioApi},${nombreEstadoSeleccionado}`;
      // const dataEstado = encodeURIComponent(parametros);
      const { data } = await ubicacionService.getUbicaciones(peticion);
      // const dota = await ubicacionService.respuestaGogle(dataEstado);
      // if (dota.data.status === 'OK') {
      //   const cordendasCentro = dota.data.results[0].geometry.location;
      //   setCenter(cordendasCentro);
      //   setzoomMap(15);
      // }
      handleGeocode(parametros, 15);
      if (data.code !== 200) return;

      const { hallazgos = [], visitasCasas = [], visitasEventos = [] } = data;
      const locaciones = [];

      hallazgos.forEach((h) => {
        h.ubicacion.idHallazgo = h.idHallazgo;
        h.tipoHallazgoCat = 'Espectaculares';
        const lat = parseFloat(h.ubicacion.latitud);
        const lng = parseFloat(h.ubicacion.longitud);
        h.ubicacion.cordenadas = {
          lat,
          lng
        };
        locaciones.push(h.ubicacion);
      });
      visitasCasas.forEach((vCasa) => {
        vCasa.ubicacion.idHallazgo = vCasa.idVisita;
        vCasa.tipoHallazgoCat = 'VisitasCasas';
        const lat = parseFloat(vCasa.ubicacion.latitud);
        const lng = parseFloat(vCasa.ubicacion.longitud);
        vCasa.ubicacion.cordenadas = {
          lat,
          lng
        };
        locaciones.push(vCasa.ubicacion);
      });
      visitasEventos.forEach((vEvento) => {
        vEvento.ubicacion.idHallazgo = vEvento.idVisita;
        vEvento.tipoHallazgoCat = 'VisitasEventos';
        const lat = parseFloat(vEvento.ubicacion.latitud);
        const lng = parseFloat(vEvento.ubicacion.longitud);
        vEvento.ubicacion.cordenadas = {
          lat,
          lng
        };
        locaciones.push(vEvento.ubicacion);
      });
      setListaLocalidades(locaciones);
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: `${error}`
      });
    }
  };

  const generarPdf = () => {
    if (listaCoordenadasSeleccionadas.length !== 0) {
      setIsModalPDF(true);
    }
  };
  const quitarMarcador = (marcador) => {
    const marcadoresRestantes = listaCoordenadasSeleccionadas.filter(
      (d) => d.idUbicacion !== marcador.idUbicacion
    );
    setListaCoordenadasSeleccionadas(marcadoresRestantes);
  };

  const onClickMarker = (_, marcador) => {
    if (listaCoordenadasSeleccionadas.find((punto) => marcador.idUbicacion === punto.idUbicacion))
      return;
    marcador.calle = marcador.calle?.replace(marcador.numero, ''); //  se quita el número de la calle para evitar duplicado
    if (marcador.numero === undefined) {
      marcador.numero = 'S/N';
    }
    const lat = [...listaCoordenadasSeleccionadas, marcador];
    setListaCoordenadasSeleccionadas(lat);
  };

  // eslint-disable-next-line no-unused-vars
  const onLoad = (mape) => {
    const recorrido = listaCoordenadasSeleccionadas.map((m) => m.cordenadas);
    const rute = new window.google.maps.Polyline({
      path: recorrido,
      geodesic: true,
      strokeColor: '#FF0000',
      strokeOpacity: 1,
      strokeWeight: 4
    });
    // eslint-disable-next-line array-callback-return
    listaLocalidades.map((m) => {
      const marker = new window.google.maps.Marker({
        position: m.cordenadas,
        title: `${'hallazgos onload:'}${m.idHallazgo}`,
        label: m.referencias,
        optimized: false,
        disableDefaultUI: true
      });
      marker.setMap(mape);
    });
    rute.setMap(mape);
  };

  const handleLoadMap = (mapRef) => {
    // Guardamos la referencia del mapa
    setMap(mapRef);
  };

  return (
    <div className="geocercas-page">
      {contextHolder}
      <Col span={24}>
        <Col span={18}>
          <HeaderPage
            section=""
            section2="Geocercas"
            title="Geocercas"
            header="Busca y traza las rutas de monitoreos de espectaculares y demás propaganda en vía pública que se han realizado."
          />
        </Col>
        <Row>
          <span style={{ color: '#FCABEE' }}>
            Selecciona los puntos de ubicación para agregar monitoreos a la ruta, al terminar
            descarga pdf.
          </span>
        </Row>
        <Row gutter={15} className="contenedor-ruta">
          <Col span={18} className="contenedor-mapa">
            <Mapa
              center={center}
              onLoad={handleLoadMap}
              streetViewControlMap={false}
              zoom={zoomMap}
              markersProps={{ points: listaLocalidades, onClick: onClickMarker }}
              routes={[listaCoordenadasSeleccionadas]}
            />
          </Col>
          <Col span={6}>
            <Form
              name="form-geocercas"
              layout="vertical"
              onFinish={handleBusquedaLocaciones}
              form={form}>
              <Col>
                <Row>
                  <InfoCircle style={{ marginLeft: '10px', marginRight: '10px' }} />
                  <span style={{ color: '#A77BB2' }}>Captura la información solicitada.</span>
                  <span className="modal-formulario-subtitulo-requeridos">
                    *Campos obligatorios.
                  </span>
                  <br /> <br /> <br />
                </Row>
                <Row>
                  <Form.Item
                    name="entidad"
                    label="Entidad"
                    rules={[{ required: true, message: 'Campo obligatorio!' }]}>
                    <Select
                      style={{ width: '300px' }}
                      fieldNames={{ value: 'idEstado', label: 'nombreEstado' }}
                      allowClear
                      optionFilterProp="children"
                      placeholder="Filtra"
                      options={catalogoEstados}
                      showSearch
                      onChange={handleChangeEntidad}
                      filterOption={(input, option) =>
                        (option?.nombreEstado ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item
                    name="municipios"
                    label="Municipio o Alcaldía"
                    rules={[{ required: true, message: 'Campo obligatorio!' }]}>
                    <Select
                      style={{ width: '300px' }}
                      fieldNames={{ value: 'id', label: 'nombre' }}
                      optionFilterProp="children"
                      placeholder="Filtra"
                      onChange={handleChangeMunicipio}
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        (option?.nombre ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      options={catalogoMunicipios}
                    />
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item
                    name="fechaMonitoreo"
                    label="Fecha de monitoreo:"
                    rules={[{ required: true, message: 'Campo obligatorio!' }]}>
                    <DatePicker
                      format={dateFormatList}
                      style={{ width: '300px' }}
                      minDate={dayjs(fechaIniciOper, dateFormat)}
                      maxDate={dayjs(fechaHoy, dateFormat)}
                    />
                  </Form.Item>
                </Row>
                <Row gutter={20} align="center">
                  <Button type="default" text="Reestablecer" onClick={limpiarMapa} />
                  <div style={{ width: 20 }} />
                  <Form.Item>
                    <Button type="primary" htmlType="submit" text="Nueva ruta">
                      Nueva
                    </Button>
                  </Form.Item>
                </Row>
              </Col>
            </Form>
          </Col>
        </Row>
        <Row>
          <h1 className="colorTitlINE">Ruta</h1>
        </Row>
        <div>
          <ListadoDirecciones
            listacordenadasSeleccionadas={listaCoordenadasSeleccionadas}
            nombreEstado={nombreEstadoSeleccionado}
            onDelete={quitarMarcador}
          />
        </div>
        <div>&nbsp;</div>
        <Row>
          <Col span={10} />
          <Col span={3}>
            <Button type="default" text="Cancelar" onClick={limpiarMapa} />
          </Col>
          <Col span={2}>
            <Button
              type="primary"
              text="Generar PDF"
              icon={<FilePdfOutlined />}
              onClick={() => {
                generarPdf();
              }}
            />
          </Col>
        </Row>
      </Col>

      <PdfGeocercas
        open={isModalPDF}
        callback={() => setIsModalPDF(false)}
        dataActa={dataActa}
        map={map}
        ubicaciones={listaCoordenadasSeleccionadas}
        catalogos={catalogoEstados}
      />
    </div>
  );
}

export default Geocercas;
